import { Fancybox } from '@fancyapps/ui';

function FancyBox() {
    Fancybox.bind('[data-fancybox]:not(.slick-cloned [data-fancybox])', {
        Carousel: {
            // Video plugin options
            Video: {
                vimeo: {
                    color: '998152', // hex WITHOUT "#"
                    byline: 1,
                    controls: 1,
                    dnt: 1,
                    muted: 0,
                },
            },

            Toolbar: {
                display: {
                    left: ['counter'],
                    middle: [],
                    right: ['autoplay', 'thumbs', 'close'],
                },
            },
        },

        on: {
            ready: function (fancybox) {
                var activeTrigger = document.activeElement;

                if (!activeTrigger) {
                    return;
                }

                if (!activeTrigger.closest('.floorplan-slider')) {
                    return;
                }

                var dialog = fancybox.container.closest('.fancybox__dialog');

                if (dialog) {
                    dialog.classList.add('fancybox__dialog--floorplan');
                }
            },
        },
    });
}

export default FancyBox;